import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSunIconSecondary(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M8 3.99c.41 0 .75-.34.75-.75V.75C8.75.34 8.41 0 8 0s-.75.34-.75.75v2.49c0 .41.33.75.75.75ZM8 5C6.35 5 5 6.34 5 8s1.35 3 3 3 3-1.35 3-3-1.34-3-3-3Zm0 4.5c-.82 0-1.5-.68-1.5-1.5S7.18 6.5 8 6.5s1.5.67 1.5 1.5S8.83 9.5 8 9.5ZM8 12c-.41 0-.75.34-.75.75v2.49c0 .41.34.75.75.75s.75-.34.75-.75v-2.49c0-.41-.34-.75-.75-.75ZM4.12 5.18a.75.75 0 1 0 1.06-1.06L3.4 2.34a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.78 1.78ZM11.9 10.84a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.75 1.75c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-1.75-1.75ZM11.4 5.34c.19 0 .38-.07.53-.22l1.72-1.72c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.72 1.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22ZM4.15 10.78l-1.8 1.8c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l1.8-1.8c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0ZM4.02 8c0-.41-.34-.75-.75-.75H.75a.749.749 0 1 0 0 1.5h2.52c.42 0 .75-.34.75-.75ZM15.24 7.25h-2.47c-.41 0-.75.34-.75.75s.34.75.75.75h2.47c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z",
    fill: "currentColor"
  }));
}

export { SvgSunIconSecondary as default };
